// production.js

const production = {
  id: 14,
  title: "Event Production",
  questions: [
    {
      question: "Do you provide event production services?",
      answer:
        "Yes, we provide sound, lighting, LED walls, stage production, and technical support.",
    },
    {
      question: "Can live streaming be arranged?",
      answer:
        "Yes, live streaming and hybrid event production services are available.",
    },
    {
      question: "Do you provide technical staff?",
      answer:
        "Yes, experienced technicians and production crews are provided for events.",
    },
  ],
};

export default production;